export enum localStorageEnum {
  'local.storage.userId' = 'user_id',
  'local.storage.firstName' = 'first_name',
  'local.storage.lastName' = 'last_name',
  'local.storage.email' = 'email',
  'local.storage.uniqueDeviceId' = 'uniqueDeviceId',
  'local.storage.sessionExpiryTime' = 'sessionExpiryTime',
  'local.storage.role' = 'userRoleID',
}

export enum sessionStorageEnum {
  'session.storage.token' = 'access_token',
}

export enum TRANSFER_PROVIDER_ACTIONS {
  SET_DEFAULT_PROVIDER = 'set_default_provider',
  SET_MINIMUM_BALANCE_THRESHOLD = 'set_minimum_balance_threshold',
  ASSIGN_BANKS_TO_PROVIDER = 'assign_banks_to_provider',
  DISABLE_PROVIDER = 'disable_provider',
  ENABLE_PROVIDER = 'enable_provider',
}

export enum ADMIN_ROLES {
  'super_admin' = '5a90f7ac-4a64-47c3-8a47-9b02174b789a',
  'csm' = '0f7a94b6-2bcd-4ec6-b16e-2dc64a3c94d3',
  'intern' = '3f02fdd2-8b41-4e47-9d12-1a4b56cd0b2a',
  'team_leads' = '4c9736af-84e4-4b56-8f3a-1f762fdf0e8e',
  'grade_2' = '8b8f6f7c-63e1-4d9f-9f2c-98e3439f2f75',
  'deputies' = 'd40b8a6f-cc8c-4db9-9d32-493a5824c8f4',
}

export enum VanReturnedPage {
  IDENTITY = 'identity',
  ADDRESS = 'address',
  UTILITY_BILL = 'utility_bill',
  FINANCIAL_INFO = 'financial_info',
}
